import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

function FaviconChanger() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <Helmet>
      <link
        rel="icon"
        href={isHome ? "/favicon2.png" : "/favicon.png"}
        type="image/png"
      />
    </Helmet>
  );
}

export default FaviconChanger;
